import React, { useContext, useEffect, useState, useRef } from "react";
import AppContext from "../../../context/AppContext";
import classNames from "classnames";
import translations from "../Translations";
import { getRcWorkflows } from "../../../service/workflow";
import { getPermittedActivities } from "../../../utils/activityPermissions";

const RcActivity = () => {
    const { rcOrgId, theme, langMode, setRcWorkflowId, setRcWorkflowName } = useContext(AppContext);
    const selectRef = useRef(null);
    const prevOrgId = useRef(null);
    const [selectedActivityName, setSelectedActivityName] = useState("");
    const [data, setData] = useState([]);
    const { selectedOption, setSelectedOption } = useContext(AppContext);

    useEffect(() => {
        if (!rcOrgId || prevOrgId.current === rcOrgId) return; 
        prevOrgId.current = rcOrgId;
        const fetchData = async () => {
            try {
                const response = await getRcWorkflows(rcOrgId);
                const workflows = response.body.value;
                if (Array.isArray(workflows)) {
                    const permitted = getPermittedActivities(workflows);
                    setData(permitted);
                    const savedWorkflowId = localStorage.getItem("RcselectedActivity");
                    if (savedWorkflowId && permitted.some(wf => wf.workflowId === savedWorkflowId)) {
                        setSelectedOption(savedWorkflowId);
                        setRcWorkflowId(savedWorkflowId);
                        setRcWorkflowName(permitted.find(wf => wf.workflowId === savedWorkflowId)?.workflowName || "");
                    } else if (permitted.length > 0) {
                        const first = permitted[0];
                        setSelectedOption(first.workflowId);
                        setRcWorkflowId(first.workflowId);
                        setRcWorkflowName(first.workflowName);
                    } else {
                        setSelectedOption("");
                        setRcWorkflowId("");
                        setRcWorkflowName("");
                    }
                } else {
                    console.error("Expected an array but got:", workflows);
                    setData([]);
                }
            } catch (error) {
                console.error("Error fetching workflows:", error);
            }
        };
        fetchData();
    }, [rcOrgId]);

    const handleOptionChange = (event) => {
        const workflowId = event.target.value;
        setSelectedOption(workflowId);
        setRcWorkflowId(workflowId);
        localStorage.setItem("RcselectedActivity", workflowId);
        const selectedWorkflow = data.find(workflow => workflow.workflowId === workflowId);
        setSelectedActivityName(selectedWorkflow ? selectedWorkflow.workflowName : "");
        setRcWorkflowName(selectedWorkflow ? selectedWorkflow.workflowName : "");
    };

    return (
        <select
            id="activities"
            ref={selectRef}
            className={classNames(
                "select cursor-pointer w-56 max-w-sm text-center text-black text-md rounded-xl appearance-none h-10 px-2.5 bg-white ",
                "focus:ring-blue-500 focus:border-blue-500 hidden",
                theme === "dark"
                    ? "dark-mode"
                    : theme === "high-contrast"
                        ? "high-contrast"
                        : "border-gray-500"
            )}
            onChange={handleOptionChange}
            value={selectedOption || ""}
            aria-label="Activity Selection"
        >
            <option value="" disabled>
                {translations[langMode].select}
            </option>
            {data.map((workflow) => (
                <option key={workflow.workflowId} value={workflow.workflowId}>
                    {workflow.workflowName}
                </option>
            ))}
        </select>
    );
};

export default RcActivity;
